import { ApiError } from '../buildApiErrorPipeline';

export type SliceError<Error = ApiError> = {
  data: Error;
  status: number;
};

export const unwrapSliceError = (error: SliceError): ApiError => error.data;
